<div class="bw-dialog info-dialog">

  <lib-page-header screenName="Legal" title="Privacy Policy">
    <mat-icon icon>privacy_tip</mat-icon>
    <ng-container subtitle>
      <span>How we collect, use, and protect your information</span>
    </ng-container>
  </lib-page-header>

  <div class="bw-body">
    <p class="intro">
      Your privacy is important to us. This Privacy Policy explains how BookWise collects, uses, and protects your information.
    </p>

    <h3>1. Information We Collect</h3>
    <p>When you use BookWise, we may collect the following types of information:</p>
    <ul>
      <li><strong>Personal Information:</strong> Name, email address, and other details you provide during sign-up.</li>
      <li><strong>Usage Data:</strong> Information about how you use our app, including interactions and preferences.</li>
      <li><strong>Device Information:</strong> Details about the device and browser you use to access BookWise.</li>
    </ul>

    <h3>2. How We Use Your Information</h3>
    <p>BookWise uses your information to:</p>
    <ul>
      <li>Provide and improve our services.</li>
      <li>Personalize your experience and tailor recommendations.</li>
      <li>Communicate updates, support, and promotional offers (with your consent).</li>
      <li>Ensure security and prevent fraud.</li>
    </ul>

    <h3>3. Sharing Your Information</h3>
    <p>BookWise does not sell your personal information. We may share your information with:</p>
    <ul>
      <li>Service providers who help us operate our app (e.g., hosting, analytics).</li>
      <li>Law enforcement, if required by law or to protect our rights.</li>
      <li>Other parties with your explicit consent.</li>
    </ul>

    <h3>4. Your Choices</h3>
    <p>You have the right to:</p>
    <ul>
      <li>Access and update your personal information.</li>
      <li>Request deletion of your account and data.</li>
      <li>Opt-out of promotional communications.</li>
    </ul>

    <h3>5. Security</h3>
    <p>We use industry-standard security measures to protect your information. However, no system is entirely secure, and we cannot guarantee absolute security.</p>

    <h3>6. Changes to This Policy</h3>
    <p>BookWise may update this Privacy Policy from time to time. We will notify you of significant changes and update the "Last Updated" date at the top of the policy.</p>
  </div>


</div>
